import React, { createContext, useContext, useEffect, useState } from "react";

import { useUser } from "./user-context";
import {
  connectToHub,
  disconnectSignalR,
  invokeHubMethod,
} from "../components/utils/signalR";
import { useSnackbar } from "../components/utils/SnackbarProvider";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useBets } from "./bets-context";
import routes from "../constants/routes";
import ConfirmationModal from "../components/utils/popups/confirmation-popup";
import { assetImages } from "../constants/assets";
import { fetchUserProfileLogic } from "../hooks/window-size/use-fetch-user-profile";
import useApiRequest from "../api/api"; // ✅ make sure the path is correct

const SignalRContext = createContext();

export const useSignalR = () => useContext(SignalRContext);

export const SignalRProvider = ({ children }) => {
  const { user, updateUser } = useUser();
  const { fetchBets } = useBets();
  const showSnackbar = useSnackbar(); // Use the global Snackbar
  const location = useLocation();
  const [connection, setConnection] = useState(null);
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const [racerDisconnectMessage, setRacerDisconnectMessage] = useState("");
  const [isBettingClosed, setIsBettingClosed] = useState(false);
  const { makeApiCall } = useApiRequest();

  const [showRacerDisconnectModal, setShowRacerDisconnectModal] =
    useState(false);

  const handleCloseRacerDisconnectModal = () => {
    setShowRacerDisconnectModal(false);
  };
  const navigateToMainMenu = () => {
    setShowRacerDisconnectModal(false);
    navigate(routes.home);
  };
  const navigate = useNavigate();
  const fetchUserProfile = async () => {
    await fetchUserProfileLogic({
      makeApiCall,
      updateUser,
      user,
    });
  };
  useEffect(() => {
    let conn = null;
    // setIsBettingClosed(true); // mark betting as closed
    // setRacerDisconnectMessage("JELLO");
    // setShowRacerDisconnectModal(true);
    // attack();
    const setupConnection = async () => {
      if (!(user?.authToken && location.pathname.includes("/race") && id)) {
        if (connection) {
          connection.off("RefreshBets");
          connection.off("EndRace");
          disconnectSignalR();
        }
        console.warn("Not Valid");
        return;
      }

      try {
        conn = await connectToHub(user?.authToken); // Pass the token explicitly
        setConnection(conn);

        if (conn) {
          // Register user object to SignalR
          const userData = {
            username: user?.username,
            identifier: user?.identifier,
            connectionId: conn.connectionId,
            raceIdentifier: id,
          };
          await invokeHubMethod("AddUserObject", userData);

          // Subscribe to SignalR events
          conn.on("RefreshBets", async (data) => {
            // showSnackbar(data.message, "success"); // Show toast normally
            fetchBets();
          });
          conn.on("CloseBettingWindow", async (data) => {
            if (location.pathname.includes("/race")) {
              showSnackbar(data.message, "success"); // Show toast normally
              setIsBettingClosed(true); // mark betting as closed
            }
          });

          conn.on("RacerDisconnected", async (data) => {
            if (location.pathname.includes("/race")) {
              setRacerDisconnectMessage(data.message);
              setShowRacerDisconnectModal(true);
              await fetchUserProfile();
            }
          });
          conn.on("EndRace", async (data) => {
            showSnackbar(data.message, "success");
            navigate(routes.home);
          });
          // *- DEPRECATED
          // conn.on("WinningUpdate", async (data) => {
          //   const Value = data.WinningAmount;
          //   const Message = data.RaceName;
          //   navigate(routes.winning_notification, {
          //     state: {
          //       Value,
          //       Message,
          //     },
          //   });
          // });
          conn.on("RaceComplete", async (data) => {
            navigate(routes.home);
            if (data.value > 0) {
              // 🏆 Winner: short delay, then go to winnings screen
              fetchUserProfile();
              navigate(routes.winning_notification, {
                state: {
                  Value: data.value,
                  Message: data.message,
                },
              });
            } else {
              // 🏁 Non-winner: just show message
              showSnackbar(data.message || "This race has ended", "success");
            }
          });
        }
      } catch (error) {
        console.error("Error setting up SignalR connection:", error);
      }
    };

    setupConnection();

    return () => {
      // console.log("Leaving");
      // if (connection) {
      //   connection.off("ReceiveNotification");
      //   disconnectSignalR();
      // }
    };
  }, [user, location.pathname]);

  return (
    <>
      <SignalRContext.Provider
        value={{ connection, invokeHubMethod, isBettingClosed }}
      >
        {children}
      </SignalRContext.Provider>
      <ConfirmationModal
        open={showRacerDisconnectModal}
        onClose={navigateToMainMenu}
        img={assetImages.warning}
        title="Racer Disconnected"
        message={racerDisconnectMessage}
        confirmButtonText="I UNDERSTAND"
        closeButtonText="GO TO MAIN MENU"
        handleSubmit={handleCloseRacerDisconnectModal}
        secondaryClick={navigateToMainMenu}
      />
    </>
  );
};
